/* The row both legal RPCs answer (change spec terms-acceptance, design 1). */

/** One row of `my_legal_status()` / `legal_accept()`. */
export interface LegalStatus {
  terms_version: string | null;
  privacy_version: string | null;
  terms_accepted_at: string | null;
  privacy_accepted_at: string | null;
  first_terms_accepted_at: string | null;
  needs_acceptance: boolean;
}

/** The one row a table-returning RPC answers (PostgREST sends an array), or null when it is not one. */
export function legalRow(data: unknown): LegalStatus | null {
  const row = Array.isArray(data) ? data[0] : data;
  if (!row || typeof row !== 'object') return null;
  const r = row as Record<string, unknown>;
  if (typeof r.needs_acceptance !== 'boolean') return null;
  const text = (v: unknown) => (typeof v === 'string' ? v : null);
  return {
    terms_version: text(r.terms_version),
    privacy_version: text(r.privacy_version),
    terms_accepted_at: text(r.terms_accepted_at),
    privacy_accepted_at: text(r.privacy_accepted_at),
    first_terms_accepted_at: text(r.first_terms_accepted_at),
    needs_acceptance: r.needs_acceptance,
  };
}
